import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';
import errorBoundary from '@ifeng-fe/errorBoundary';

import RightTit from '../rightTit';

class HotNews extends React.PureComponent {
    render() {
        const { content } = this.props;

        return (
            <div className={styles.ranking}>
                <RightTit txt="点击排行" />
                <div className={styles.list}>
                    <ul>
                        {content.map((item, index) => {
                            const numClassName = index <= 2 ? `${styles.numIcon} ${styles.red}` : styles.numIcon;

                            return (
                                <li key={index}>
                                    <i className={numClassName}>{index + 1}</i>
                                    <a href={item.url} target="_blank" rel={rel}>
                                        <span>{item.title}</span>
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        );
    }
}

HotNews.propTypes = { content: PropTypes.array };
HotNews.defaultProps = {};

export default errorBoundary(HotNews);
